import _get from 'lodash/get';
import _set from 'lodash/set';
import _assign from 'lodash/assign';
import ErrorLog from '@mi/youpin-err-log';
import CommonBridge from 'common/CommonBridge';

const hawkEyeStatWeb = (data) => {
  try {
    const img = new Image();
    img.onload = function () {};
    img.onerror = function () {};
    const keys = Object.keys(data);
    const url = `https://stat.youpin.mi.com/0.gif?timestamp=${Date.now() / 1000}${keys
      .map((key) => `&${key}=${encodeURIComponent(data[key])}`)
      .join('')}`;
    console.log(url);
    img.src = url;
  } catch (e) {}
};
class ErrorLogWeb {
  constructor(hawkEyeStat) {
    this.hawkEyeStat = hawkEyeStat;
  }

  log(params, options = {}) {
    try {
      const type = params.statType;
      // type错误直接返回
      if (!type) {
        return false;
      }
      const fun = () => {
        return this.hawkEyeStat(params);
      };
      // if (options && options.isForce) {
      //   return fun();
      // } else {
      //   return fun();
      //   // return debounce(fun, type, count);
      // }
      return fun();
    } catch (error) {
      console.log('上报信息有误');
    }
  }
}

const hawkEyeStat = (data) => {
  const keys = Object.keys(data);
  const url = `https://stat.youpin.mi.com/0.gif?timestamp=${Date.now() / 1000}${keys
    .map((key) => `&${key}=${encodeURIComponent(data[key])}`)
    .join('')}`;
  try {
    fetch(url);
  } catch (e) {}
};
// 初始化错误日志上报sdk，需要传入客户端方法
const Logger = CommonBridge.isWeb() ? new ErrorLogWeb(hawkEyeStatWeb) : new ErrorLog(hawkEyeStat);

let TimeSpans = {
  performance: {},
  netWork: {},
};
let LoggerExtras = {};
const performanceNow = function () {
  return Date.now();
};

/**
 * 需要加渲染信息的页面的name
 * 该页面务必不要覆盖BaseNavigationView的component(will|Did)Update、componentDidMount
 * 需要自定义的话用super调用一下
 * @type {*[]}
 */
const AllowPage = [
  'Order',
  'OrderDetail',
  'OrderList',
  'Detail',
  'Cart',
  'AfterServiceList',
  'AfterService',
  'CheckoutCard',
  'Check',
];

const UtilLogger = {
  /**
   * 手动添加总时间记录
   * @param {string} key
   * @param {number} lengthInMs
   * @param {string} type
   */
  addTimespan(key, lengthInMs, type) {
    if (this.hasTimespan(key, type)) {
      // if (__DEV__) {
      //   console.log(
      //     'PerformanceLogger: Attempting to add a timespan that already exists ',
      //     key,
      //     type
      //   );
      // }
      return;
    }
    _set(TimeSpans, [type, key], {
      totalTime: lengthInMs,
    });
  },

  /**
   * 记录起始时间
   * @param {string} key
   * @param {string} type
   */
  startTimespan(key, type) {
    if (this.hasTimespan(key, type)) {
      // if (__DEV__) {
      //   console.log('PerformanceLogger: Attempting to start a timespan that already exists ', key, type);
      // }
      return;
    }

    _set(TimeSpans, [type, key], {
      startTime: performanceNow(),
    });
  },

  /**
   * 记录结束时间，并根据起始时间算出总时间
   * @param key
   * @param type
   */
  stopTimespan(key, type) {
    const timeSpan = _get(TimeSpans, [type, key]);
    if (!timeSpan || !timeSpan.startTime) {
      // if (__DEV__) {
      //   console.log(
      //     'PerformanceLogger: Attempting to end a timespan that has not started ',
      //     key,
      //   );
      // }
      return;
    }
    if (timeSpan.endTime) {
      // if (__DEV__) {
      //   console.log('PerformanceLogger: Attempting to end a timespan that has already ended ', key);
      // }
      return;
    }
    const now = performanceNow();
    _assign(timeSpan, {
      endTime: now,
      totalTime: now - timeSpan.startTime || 0,
    });
  },

  /**
   * 清空所有变量
   */
  clear() {
    TimeSpans = {};
    LoggerExtras = {};
  },

  /**
   * 判断是否存在某个key的时间记录
   * @param key
   * @param type
   * @returns {boolean}
   */
  hasTimespan(key, type) {
    return !!_get(TimeSpans, [type, key]);
  },

  /**
   * 清除某个key的时间记录
   * @param key
   * @param type
   */
  clearSomeTimespan(key, type) {
    delete TimeSpans[type][key];
  },

  getTimeSpans() {
    return TimeSpans;
  },
  currentTimestamp() {
    return performanceNow();
  },
  /**
   * 设置某个key的额外信息
   * @param {string} key
   * @param {Object} value
   */
  setExtra(key, value) {
    if (LoggerExtras[key]) {
      // if (__DEV__) {
      //   console.log('PerformanceLogger: Attempting to set an extra that already exists ', {
      //     key,
      //     currentValue: LoggerExtras[key],
      //     attemptedValue: value,
      //   });
      // }
      return;
    }
    LoggerExtras[key] = value;
  },

  getExtras() {
    return LoggerExtras;
  },

  /**
   * 对performance日志进行数据转换并上传
   * @param name
   * @returns {{page_url: *, statType: string, statInfo: Object}}
   */
  mergeUploadData(name) {
    if (!name) {
      return;
    }
    const statInfo = _get(LoggerExtras, name, {});
    const data = {
      statType: 'performance',
      pageUrl: _get(statInfo, 'pageUrl', ''),
      platform: 'rn',
    };

    _assign(statInfo, {
      renderTime: _get(TimeSpans, ['performance', name, 'totalTime']),
      reqTime: _get(TimeSpans, ['netWork', name, 'totalTime']),
    });
    delete statInfo.pageUrl;
    data.statInfo = JSON.stringify(statInfo);
    if (this.checkData(data)) {
      return;
    }
    this.uploadPerformance(data);
    return data;
  },

  /**
   * 上传performance日志
   * @param data
   * @returns {Promise<*>}
   */
  uploadPerformance(data) {
    this.clear();
    // if (__DEV__) {
    //   return console.log(data);
    // }
    Logger.log(data);
  },

  /**
   * 上传错误日志
   * @param data
   * @returns {Promise<*>}
   */
  uploadError(data) {
    if (__DEV__) {
      return console.warn('!!!请修复该问题：', data);
    }
    Logger.log(data);
  },

  checkData(data) {
    const { pageUrl, statInfo } = data;
    return !pageUrl || statInfo === '{}';
  },

  isAllowRecord(pageName) {
    return AllowPage.includes(pageName);
  },
  logPerformance(data) {
    Logger.log(data);
  },
};

export { UtilLogger };
